<script>
/**
 * ****************************************************************************
 * @description     :   MainMenu
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapState, mapMutations } from 'vuex';

import { MSG_TYPE } from '@/utils/messages';

/**
 * import template
 */
import template from './template.html';

/**
 * Define main layout
 */
const ModalMessage = {
    name: 'ModalMessage',
    template: template,
    computed: {
        ...mapState('app', ['modalMessage', 'isShowModalMessage', 'showBtnCancelWarning']),
        showModal: {
            get() {
                return this.isShowModalMessage;
            },
            set(value) {
                this.updateShowModalMessage(value);
            }
        },
        showCancel() {
            let status = false;
            if (this.modalMessage.type == MSG_TYPE.CONFIRM) {
                status = true;
            } else if (this.modalMessage.type == MSG_TYPE.WARNING && this.modalMessage.showBtnCancelWarning) {
                status = true;
            } else if (this.modalMessage.type == MSG_TYPE.CUSTOM) {
                status = true;
            }
            return status;
        },
        showTitle() {
            return this.modalMessage.title && this.modalMessage.title != '';
        },
        showCustom() {
            return this.modalMessage.type == MSG_TYPE.CUSTOM;
        }
    },
    data() {
        let isDefaultColorSettings = false;
        if (localStorage.getItem('mainColor') == null || localStorage.getItem('subColor') == null || localStorage.getItem('backColor') == null) {
            isDefaultColorSettings = true;
        }
        const mainColor = JSON.parse(localStorage.getItem('mainColor'));
        const subColor = JSON.parse(localStorage.getItem('subColor'));
        const backColor = JSON.parse(localStorage.getItem('backColor'));
        // check customer module or manager module
        let isManager = localStorage.getItem('mode') == 1 ? true : false;
        return {
            msgType: MSG_TYPE,
            mainColor: mainColor,
            subColor: subColor,
            backColor: backColor,
            defaultColorSettings: isDefaultColorSettings,
            isManager: isManager,
            lastWidth: 0,
            lastHeight: 0
        };
    },
    mounted() {
        document.addEventListener('shown.bs.modal', this.popupFocus);
        this.lastWidth = window.innerWidth;
        this.lastHeight = window.innerHeight;
    },
    beforeUnmount() {
        document.removeEventListener('shown.bs.modal', this.popupFocus);
    },
    methods: {
        ...mapMutations('app', ['hideModalMessage', 'updateShowModalMessage']),
        releaseModalFocus() {
            const active = document.activeElement;
            if (active && typeof active.blur === 'function') {
                active.blur();
            }
        },
        onClickOk() {
            const callback = this.modalMessage.callback;
            this.releaseModalFocus();
            this.hideModalMessage();
            if (callback) {
                setTimeout(() => {
                    callback(true);
                }, 300);
            }
        },
        onClickCancel() {
            const callback = this.modalMessage.callbackCancel;
            this.releaseModalFocus();
            this.hideModalMessage();
            if (callback) {
                setTimeout(() => {
                    callback(true);
                }, 300);
            }
        },
        onClickCustom() {
            const callback = this.modalMessage.callbackCustom;
            this.releaseModalFocus();
            this.hideModalMessage();
            if (callback) {
                setTimeout(() => {
                    callback(true);
                }, 300);
            }
        },
        clickBackdrop() {
            const classModal = document.getElementById('modal-no-backdrop').classList;
            classModal.add('modal-static');
            setTimeout(() => {
                classModal.remove('modal-static');
            }, 200);
        },
        popupFocus() {
            this.$nextTick(() => {
                let btnFocus = '';
                if (localStorage.getItem('mode') == 1) {
                    btnFocus = document.querySelectorAll(`.btn-confirm-ok`);
                } else {
                    btnFocus = document.querySelectorAll(`.btn-confirm-cancel`);
                }

                if (btnFocus.length > 0) {
                    btnFocus[0].focus();
                }
            });
        },
        onModalHide(event) {
            this.releaseModalFocus();
            if (window.innerWidth != this.lastWidth || window.innerHeight != this.lastHeight) {
                this.lastWidth = window.innerWidth;
                this.lastHeight = window.innerHeight;
                event.preventDefault();
                this.updateShowModalMessage(true);
                return;
            }
        }
    }
};
export default ModalMessage;
</script>
